<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">mail</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.emailEditor' | translate}}</span>
      </div>
      <!-- SEARCH -->

      <!-- / SEARCH -->
      <button mat-raised-button
        class="add-product-button mat-white-bg my-12 mt-sm-0"
        (click)="saveEmails()">
        <span>{{'main.save' | translate}}</span>
      </button>
    </div>

    <div class="content-card mat-white-bg" fusePerfectScrollbar>

      <div class="table-data">
        <table style="width: 100%; table-layout: fixed">
          <thead>
            <tr>
              <td style="width: 3%"></td>
              <td style="width: 10%"></td>
              <td style="width: 47%">{{'img_url' | translate}}</td>
              <td style="width: 40%;padding-left: 15px">{{'link_for_image' | translate}}</td>
            </tr>
          </thead>
          @for (el of data; track el; let i = $index) {
            <tr>
              <td style="width: 3%">{{i + 1}}.</td>
              <td style="width: 10%">{{el.type | translate}}</td>
              <td style="width: 47%">
                <mat-form-field style="display: block">
                  <input matInput value="{{el?.data}}" (keyup)="changeData(el.id, $event.target.value, 'data')">
                </mat-form-field>
              </td>
              <td style="width: 40%; padding-left: 15px">
                <mat-form-field style="display: block">
                  <input matInput value="{{el?.link}}" (keyup)="changeData(el.id, $event.target.value, 'link')">
                </mat-form-field>
              </td>
            </tr>
          }
        </table>
      </div>

      <div class="email-data" [innerHTML]="allMailBody"></div>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
